import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import InputFields from '../components/InputFields';
import { useAddMenu, useGetAllCategory, useGetAllDairyItems, useGetAllFarsanItems, useGetAllGrocery, useGetAllVasanItems, useGetAllVegetables, useUpdateMenu } from '../hooks/hooks';
import VegetableItems from './../components/VegetableItems'
import GroceriesItems from '../components/GroceriesItems';
import DairyItems from '../components/DairyItems';
import FarsanItems from '../components/FarsanItems';
import VasanItems from '../components/VasanItems';
import { useLocation, useNavigate } from 'react-router-dom';
import { showErrorToast, showSuccessToast } from '../components/common';
import { getMenuById } from '../API/menu';


function AddMenu() {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    // const { selectedMenu, isEdit } = location?.state || {};

    const [isEdit, setIsEdit] = useState(location?.state?.isEdit || false);
    const [selectedMenu, setSelectedMenu] = useState(location?.state?.selectedMenu || null);

    const [inputValue, setInputValue] = useState({ name: "", isActive: true, categoryId: "", nameEn: "", price: "" });
    const [Error, setError] = useState({ name: "", isActive: true, categoryId: "", nameEn: "", price: "", all: "" });
    const { data: categoryList } = useGetAllCategory();

    const { data: allVegetables } = useGetAllVegetables();
    const { data: allGrocery } = useGetAllGrocery();
    const { data: allDairyItems } = useGetAllDairyItems();
    const { data: allFarsanItems } = useGetAllFarsanItems();
    const { data: allVasanItems } = useGetAllVasanItems();
    const { mutate: addMenu } = useAddMenu();
    const { mutate: updateMenu } = useUpdateMenu();

    const [isLoading, setIsLoading] = useState(false);
    const [vegetableRows, setVegetableRows] = useState([{ vegetable: null, unitType: null, quantity: '' }]);
    const [GroceryRows, setGroceryRows] = useState([{ grocery: null, unitType: null, quantity: '' }]);
    const [DairyRows, setDairyRows] = useState([{ dairy: null, unitType: null, quantity: '' }]);
    const [FarsanRows, setFarsanRows] = useState([{ farsan: null, unitType: null, quantity: '' }]);
    const [VasanRows, setVasanRows] = useState([{ vasan: null, unitType: null, quantity: '' }]);
    const [isOpenConfirm, setIsOpenConfirm] = useState(false);
    const sectionRef = useRef(null);
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        if (isExpanded && sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    }, [isExpanded]);

    useEffect(() => {
        if (selectedMenu) {
            setInputValue({
                categoryId: selectedMenu.category._id,
                name: selectedMenu.menuName,
                nameEn: selectedMenu.menuNameEn
            });

            if (selectedMenu.items.vegetable && selectedMenu.items.vegetable.length > 0) {
                setVegetableRows(selectedMenu.items.vegetable);
            }

            if (selectedMenu.items.grocery && selectedMenu.items.grocery.length > 0) {
                setGroceryRows(selectedMenu.items.grocery);
            }

            if (selectedMenu.items.dairy && selectedMenu.items.dairy.length > 0) {
                setDairyRows(selectedMenu.items.dairy);
            }

            if (selectedMenu.items.farsan && selectedMenu.items.farsan.length > 0) {
                setFarsanRows(selectedMenu.items.farsan);
            }

            if (selectedMenu.items.vasan && selectedMenu.items.vasan.length > 0) {
                setVasanRows(selectedMenu.items.vasan);
            }
        }
    }, [selectedMenu])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValue({
            ...inputValue,
            [name]: value.toString(),
        });
        setError({ ...Error, name: "", isActive: true, categoryId: '', all: "", nameEn: "" });
    };

    const onSubmit = () => {

        if (inputValue.categoryId === "") {
            setError({ ...Error, categoryId: t('Select_Category_Er') });
            return;
        }

        if (inputValue.name.toString().trim() === "") {
            setError({ ...Error, name: t('Menu_Name_Er') });
            return;
        }
        // if (inputValue.nameEn.toString().trim() === "") {
        //     setError({ ...Error, nameEn: t('Menu_NameEn_Er') });
        //     return;
        // }

        setIsLoading(true);

        const isArrayValid = (array, key) => {
            let finalArrayList = array.length === 0 ? null : array.filter(item => item[key] && item.unitType && item.unitType !== '' && item.quantity && item.quantity !== '');
            return finalArrayList != null && finalArrayList.length > 0 ? finalArrayList : null;
        };

        if (isEdit) {
            const updateItem = {
                name: inputValue.name,
                nameEn: inputValue.nameEn,
                price: inputValue.price,
                isActive: inputValue.isActive,
                categoryId: inputValue.categoryId,
                _id: selectedMenu._id,
                vegetableRows: isArrayValid(vegetableRows, 'vegetable'),
                GroceryRows: isArrayValid(GroceryRows, 'grocery'),
                DairyRows: isArrayValid(DairyRows, 'dairy'),
                FarsanRows: isArrayValid(FarsanRows, 'farsan'),
                VasanRows: isArrayValid(VasanRows, 'vasan')
            }
            updateMenu(updateItem, {
                onSuccess: (res) => {
                    showSuccessToast(res?.data?.message);
                    setIsLoading(false);
                    setError({ ...Error, name: "", isActive: true, categoryId: '', all: "" });
                },
                onError: (err) => {
                    setIsLoading(false);
                    setError({ ...Error, all: err.response.data.error });
                },
            });
        } else {

            const addItem = {
                name: inputValue.name,
                nameEn: inputValue.nameEn,
                price: inputValue.price,
                isActive: inputValue.isActive,
                categoryId: inputValue.categoryId,
                vegetableRows: isArrayValid(vegetableRows, 'vegetable'),
                GroceryRows: isArrayValid(GroceryRows, 'grocery'),
                DairyRows: isArrayValid(DairyRows, 'dairy'),
                FarsanRows: isArrayValid(FarsanRows, 'farsan'),
                VasanRows: isArrayValid(VasanRows, 'vasan')
            }

            addMenu(addItem, {
                onSuccess: (res) => {
                    showSuccessToast(res?.message);
                    setIsLoading(false);
                    setIsEdit(true);
                    getMenu(res.data._id);
                    setError({ ...Error, name: '' });
                },
                onError: (err) => {
                    setIsLoading(false);
                    showErrorToast(err.response.data.error);
                    setError({ ...Error, all: err.response.data.error });
                },
            });

        }
    }

    const getMenu = async (_id) => {
        const menu = await getMenuById(_id);
        setSelectedMenu(menu.data.data);
    }

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 px-6 py-8" ref={sectionRef}>
                {/* Header Section */}
                <div className=" mx-auto">
                    <div className="mb-8">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-4">
                                <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center">
                                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                    </svg>
                                </div>
                                <div>
                                    <h1 className="text-3xl font-bold text-secondary">
                                        {isEdit ? t('um_title') : t('am_title')}
                                    </h1>
                                    <p className="text-gray-600 mt-1">
                                        {isEdit ? t('Update_existing_menu') : t('create_new_menu')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Main Form Card */}
                    <div className="bg-white rounded-2xl shadow-card border border-gray-100 overflow-hidden">
                        {/* Form Header */}
                        <div className="bg-gradient-to-r from-teal-600 to-cyan-700 px-8 py-4">
                            <h2 className="text-xl font-semibold text-white">
                                {t('menu_information')}
                            </h2>
                            <p className="text-teal-100 mt-1 text-sm">
                                {t('menu_information_description')}
                            </p>
                        </div>

                        {/* Form Content */}
                        <div className="p-8">
                            {/* Menu Information Grid */}
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                {/* Menu Name Gujarati */}
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-gray-700 flex items-center">
                                        <span className="w-2 h-2 bg-primary rounded-full mr-2"></span>
                                        {t('menu_name_Gu')}
                                    </label>
                                    <InputFields
                                        name="name"
                                        label="menu name"
                                        type="text"
                                        placeholder={t('pl_menu_name')}
                                        isHideLabel="false"
                                        isFixedLabel="true"
                                        disabled={isLoading}
                                        handleChange={(e) => handleChange(e)}
                                        value={inputValue?.name}
                                        className="w-full px-3 py-2 text-gray-900 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 hover:bg-gray-100 text-sm"
                                    />
                                    {Error?.name && (
                                        <div className="flex items-center text-red-500 text-xs mt-1">
                                            <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                            </svg>
                                            {Error?.name}
                                        </div>
                                    )}
                                </div>

                                {/* Menu Name English */}
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-gray-700 flex items-center">
                                        <span className="w-2 h-2 bg-primary rounded-full mr-2"></span>
                                        {t('menu_name_En')}
                                    </label>
                                    <InputFields
                                        name="nameEn"
                                        label="menu name"
                                        type="text"
                                        placeholder={t('pl_menu_name')}
                                        isHideLabel="false"
                                        isFixedLabel="true"
                                        disabled={isLoading}
                                        handleChange={(e) => handleChange(e)}
                                        value={inputValue?.nameEn}
                                        className="w-full px-3 py-2 text-gray-900 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 hover:bg-gray-100 text-sm"
                                    />
                                    {Error?.nameEn && (
                                        <div className="flex items-center text-red-500 text-xs mt-1">
                                            <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                            </svg>
                                            {Error?.nameEn}
                                        </div>
                                    )}
                                </div>

                                {/* Category */}
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-gray-700 flex items-center">
                                        <span className="w-2 h-2 bg-primary rounded-full mr-2"></span>
                                        {t('Category')}
                                    </label>
                                    <div className="relative">
                                        <select
                                            name="categoryId"
                                            value={inputValue.categoryId}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 text-gray-900 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 hover:bg-gray-100 appearance-none cursor-pointer text-sm"
                                        >
                                            <option value="" disabled selected>{t('select_options')}</option>
                                            {categoryList && categoryList.map((category) => (
                                                <option key={category._id} value={category._id}>
                                                    {category.categoryName}
                                                </option>
                                            ))}
                                        </select>
                                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </div>
                                    </div>
                                    {Error?.categoryId && (
                                        <div className="flex items-center text-red-500 text-xs mt-1">
                                            <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                            </svg>
                                            {Error?.categoryId}
                                        </div>
                                    )}
                                </div>

                                {/* Price */}
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-gray-700 flex items-center">
                                        <span className="w-2 h-2 bg-primary rounded-full mr-2"></span>
                                        {t('pl_menu_price')}
                                    </label>
                                    <InputFields
                                        name="price"
                                        label="menu price"
                                        type="text"
                                        placeholder={t('pl_menu_price')}
                                        isHideLabel="false"
                                        isFixedLabel="true"
                                        disabled={isLoading}
                                        handleChange={(e) => handleChange(e)}
                                        value={inputValue?.price}
                                        className="w-full px-3 py-2 text-gray-900 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 hover:bg-gray-100 text-sm"
                                    />
                                    {Error?.price && (
                                        <div className="flex items-center text-red-500 text-xs mt-1">
                                            <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                            </svg>
                                            {Error?.price}
                                        </div>
                                    )}
                                </div>


                            </div>
                        </div>
                    </div>

                    {/* Items Sections */}
                    <div className="mt-8 space-y-6">
                        <VegetableItems
                            allVegetables={allVegetables}
                            vegetableRows={vegetableRows}
                            setVegetableRows={setVegetableRows}>
                        </VegetableItems>

                        <GroceriesItems
                            allGrocery={allGrocery}
                            GroceryRows={GroceryRows}
                            setGroceryRows={setGroceryRows}>
                        </GroceriesItems>

                        <DairyItems
                            allDairyItems={allDairyItems}
                            DairyRows={DairyRows}
                            setDairyRows={setDairyRows}
                        ></DairyItems>

                        <FarsanItems
                            allFarsanItems={allFarsanItems}
                            FarsanRows={FarsanRows}
                            setFarsanRows={setFarsanRows}
                        ></FarsanItems>
                        
                        <VasanItems
                            allVasanItems={allVasanItems}
                            VasanRows={VasanRows}
                            setVasanRows={setVasanRows}
                            isExpanded={isExpanded}
                            setIsExpanded={setIsExpanded}
                        ></VasanItems>
                    </div>

                    {/* Action Buttons */}
                    <div className="mt-12 flex justify-end gap-3">
                        <button 
                            className="px-4 py-2 border-2 border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-all duration-200 flex items-center justify-center w-fit"
                            onClick={() => {
                                setIsOpenConfirm(true);
                            }}
                        >
                            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            {t('btnCancel')}
                        </button>
                        <button 
                            className="px-4 py-2 bg-gradient-to-r from-primary to-secondary text-white rounded-lg font-medium hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center w-fit"
                            onClick={onSubmit}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <svg
                                        className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        ></path>
                                    </svg>
                                    Saving...
                                </>
                            ) : (
                                <>
                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    {t('btnSave')}
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Confirmation Modal */}
            {isOpenConfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl">
                        <div className="text-center">
                            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                {t('Are_u_sure')}
                            </h3>
                            <p className="text-gray-600 mb-6">
                                {t('Are_u_desc')}
                            </p>
                            <div className="flex gap-3">
                                <button 
                                    className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                                    onClick={() => setIsOpenConfirm(false)}
                                >
                                    {t('NO')}
                                </button>
                                <button 
                                    className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                                    onClick={() => {
                                        setIsOpenConfirm(false);
                                        navigate('/menu');
                                    }}
                                >
                                    {t('yes')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default AddMenu